
export const host = '' //'/xhykt'小程序里

export const childWebsite = process.env.NODE_ENV != 'production' ? 'http://ke.xhce.cn': window.location.host // 'http://ke.xhce.cn' //'10.18.0.127:8033' ''

export const staticHost = 'https://xiaochengxu.xhe.cn/xhyktimg'  //'http://kestatic.xhe.cn'
// export const staticHost = 'http://wantongstatic.91miwei.com'

export let payVipUrl = `${host}/to/alipay`

export const sellType = {
	'COURSE': 'course',
	'COURSECHAPTERS': 'mulcourse',
	'PACKAGE':'package'
}

export const windowWidth = document.documentElement.clientWidth
export const windowHeight =document.documentElement.clientHeight// window.screen.availHeight//



// WEBPACK FOOTER //
// ./src/common/js/config.js